import cn from "classnames";
import ArrowLeft30Svg from "../../assets/custom-icons/arrow-left-30.svg?react";
import ArrowRight30Svg from "../../assets/custom-icons/arrow-right-30.svg?react";
import DoubleEllipsisSvg from "../../assets/custom-icons/double-ellipsis.svg?react";
import Practice1Svg from "../../assets/custom-icons/practice-1.svg?react";
import Practice2Svg from "../../assets/custom-icons/practice-2.svg?react";
import Practice3Svg from "../../assets/custom-icons/practice-3.svg?react";
import QualificationsSvg from "../../assets/custom-icons/qualifications.svg?react";
import RaceSvg from "../../assets/custom-icons/race.svg?react";
import SprintShootoutSvg from "../../assets/custom-icons/sprint-shootout.svg?react";
import SprintSvg from "../../assets/custom-icons/sprint.svg?react";
import FigmaSvg from "../../assets/custom-icons/figma.svg?react";
import GitHubSvg from "../../assets/custom-icons/github.svg?react";
import TwitterSvg from "../../assets/custom-icons/twitter.svg?react";
import AspectRatioOffSvg from "../../assets/custom-icons/aspect-ratio-off.svg?react";
import AspectRatioOnSvg from "../../assets/custom-icons/aspect-ratio-on.svg?react";
import ClosedCaptionsOffSvg from "../../assets/custom-icons/closed-captions-off.svg?react";
import ClosedCaptionsOnSvg from "../../assets/custom-icons/closed-captions-on.svg?react";
import TimeOffsetOnSvg from "../../assets/custom-icons/time-offset-on.svg?react";
import TimeOffsetOffSvg from "../../assets/custom-icons/time-offset-off.svg?react";
import Test1Svg from "../../assets/custom-icons/test-1.svg?react";
import Test2Svg from "../../assets/custom-icons/test-2.svg?react";
import Test3Svg from "../../assets/custom-icons/test-3.svg?react";
import TestGeneralSvg from "../../assets/custom-icons/test-general.svg?react";

import styles from "./CustomIcons.module.scss";

export const ArrowLeft30Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <ArrowLeft30Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const ArrowRight30Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <ArrowRight30Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const DoubleEllipsisIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <DoubleEllipsisSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const Practice1Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <Practice1Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const Practice2Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <Practice2Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const Practice3Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <Practice3Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const QualificationsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <QualificationsSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const RaceIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <RaceSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const SprintShootoutIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <SprintShootoutSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const SprintIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <SprintSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const FigmaIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <FigmaSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const GitHubIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <GitHubSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const TwitterIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <TwitterSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const AspectRatioOffIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <AspectRatioOffSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const AspectRatioOnIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <AspectRatioOnSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const ClosedCaptionsOffIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <ClosedCaptionsOffSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const ClosedCaptionsOnIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <ClosedCaptionsOnSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const TimeOffsetOnIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <TimeOffsetOnSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const TimeOffsetOffIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <TimeOffsetOffSvg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const Test1Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <Test1Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const Test2Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <Test2Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const Test3Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return <Test3Svg {...props} className={cn(styles.wrapper, props.className)} />;
};

export const TestGeneralIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <TestGeneralSvg {...props} className={cn(styles.wrapper, props.className)} />;
};
